/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { TrackItDataTypeDto } from './TrackItDataTypeDto';
import {
    TrackItDataTypeDtoFromJSON,
    TrackItDataTypeDtoFromJSONTyped,
    TrackItDataTypeDtoToJSON,
} from './TrackItDataTypeDto';
import type { BeamConstancyWorkResultDtoOutput } from './BeamConstancyWorkResultDtoOutput';
import {
    BeamConstancyWorkResultDtoOutputFromJSON,
    BeamConstancyWorkResultDtoOutputFromJSONTyped,
    BeamConstancyWorkResultDtoOutputToJSON,
} from './BeamConstancyWorkResultDtoOutput';
import type { EvaluationResultDto } from './EvaluationResultDto';
import {
    EvaluationResultDtoFromJSON,
    EvaluationResultDtoFromJSONTyped,
    EvaluationResultDtoToJSON,
} from './EvaluationResultDto';
import type { TrackItTaskWorkResultDtoTrackItMeasurement } from './TrackItTaskWorkResultDtoTrackItMeasurement';
import {
    TrackItTaskWorkResultDtoTrackItMeasurementFromJSON,
    TrackItTaskWorkResultDtoTrackItMeasurementFromJSONTyped,
    TrackItTaskWorkResultDtoTrackItMeasurementToJSON,
} from './TrackItTaskWorkResultDtoTrackItMeasurement';
import type { ResultState } from './ResultState';
import {
    ResultStateFromJSON,
    ResultStateFromJSONTyped,
    ResultStateToJSON,
} from './ResultState';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { ResultHistoryEntryDto } from './ResultHistoryEntryDto';
import {
    ResultHistoryEntryDtoFromJSON,
    ResultHistoryEntryDtoFromJSONTyped,
    ResultHistoryEntryDtoToJSON,
} from './ResultHistoryEntryDto';
import type { BeamConstancyWorkResultDtoCreatorUser } from './BeamConstancyWorkResultDtoCreatorUser';
import {
    BeamConstancyWorkResultDtoCreatorUserFromJSON,
    BeamConstancyWorkResultDtoCreatorUserFromJSONTyped,
    BeamConstancyWorkResultDtoCreatorUserToJSON,
} from './BeamConstancyWorkResultDtoCreatorUser';

/**
 * 
 * @export
 * @interface TrackItTaskWorkResultDto
 */
export interface TrackItTaskWorkResultDto {
    /**
     * 
     * @type {string}
     * @memberof TrackItTaskWorkResultDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TrackItTaskWorkResultDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof TrackItTaskWorkResultDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItTaskWorkResultDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItTaskWorkResultDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {ResultState}
     * @memberof TrackItTaskWorkResultDto
     */
    state?: ResultState;
    /**
     * 
     * @type {BeamConstancyWorkResultDtoOutput}
     * @memberof TrackItTaskWorkResultDto
     */
    output?: BeamConstancyWorkResultDtoOutput | null;
    /**
     * 
     * @type {BeamConstancyWorkResultDtoCreatorUser}
     * @memberof TrackItTaskWorkResultDto
     */
    creatorUser?: BeamConstancyWorkResultDtoCreatorUser | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItTaskWorkResultDto
     */
    workStepId?: string;
    /**
     * 
     * @type {Array<EvaluationResultDto>}
     * @memberof TrackItTaskWorkResultDto
     */
    evaluationResults?: Array<EvaluationResultDto> | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItTaskWorkResultDto
     */
    trackItMeasurementId?: number;
    /**
     * 
     * @type {TrackItTaskWorkResultDtoTrackItMeasurement}
     * @memberof TrackItTaskWorkResultDto
     */
    trackItMeasurement?: TrackItTaskWorkResultDtoTrackItMeasurement | null;
    /**
     * 
     * @type {Array<TrackItDataTypeDto>}
     * @memberof TrackItTaskWorkResultDto
     */
    trackItDataTypesWithoutEvaluation?: Array<TrackItDataTypeDto> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrackItTaskWorkResultDto
     */
    unmappedEvaluationIds?: Array<string> | null;
    /**
     * 
     * @type {Array<ResultHistoryEntryDto>}
     * @memberof TrackItTaskWorkResultDto
     */
    history?: Array<ResultHistoryEntryDto> | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItTaskWorkResultDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItTaskWorkResultDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItTaskWorkResultDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof TrackItTaskWorkResultDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItTaskWorkResultDto
     */
    $type?: TrackItTaskWorkResultDtoTypeEnum;
}


/**
 * @export
 */
export const TrackItTaskWorkResultDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoTrackItTaskWorkResultDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.TrackItTaskWorkResultDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TrackItTaskWorkResultDtoTypeEnum = typeof TrackItTaskWorkResultDtoTypeEnum[keyof typeof TrackItTaskWorkResultDtoTypeEnum];



/**
 * Check if a given object implements the TrackItTaskWorkResultDto interface.
 */
export function instanceOfTrackItTaskWorkResultDto(value?: unknown): value is TrackItTaskWorkResultDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TrackItTaskWorkResultDtoTypeEnum)[0];
}

export function TrackItTaskWorkResultDtoFromJSON(json: any): TrackItTaskWorkResultDto {
    return TrackItTaskWorkResultDtoFromJSONTyped(json, false);
}

export function TrackItTaskWorkResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItTaskWorkResultDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'state': json['state'] == null ? undefined : ResultStateFromJSON(json['state']),
        'output': json['output'] == null ? undefined : BeamConstancyWorkResultDtoOutputFromJSON(json['output']),
        'creatorUser': json['creatorUser'] == null ? undefined : BeamConstancyWorkResultDtoCreatorUserFromJSON(json['creatorUser']),
        'workStepId': json['workStepId'] == null ? undefined : json['workStepId'],
        'evaluationResults': json['evaluationResults'] == null ? undefined : ((json['evaluationResults'] as Array<any>).map(EvaluationResultDtoFromJSON)),
        'trackItMeasurementId': json['trackItMeasurementId'] == null ? undefined : json['trackItMeasurementId'],
        'trackItMeasurement': json['trackItMeasurement'] == null ? undefined : TrackItTaskWorkResultDtoTrackItMeasurementFromJSON(json['trackItMeasurement']),
        'trackItDataTypesWithoutEvaluation': json['trackItDataTypesWithoutEvaluation'] == null ? undefined : ((json['trackItDataTypesWithoutEvaluation'] as Array<any>).map(TrackItDataTypeDtoFromJSON)),
        'unmappedEvaluationIds': json['unmappedEvaluationIds'] == null ? undefined : json['unmappedEvaluationIds'],
        'history': json['history'] == null ? undefined : ((json['history'] as Array<any>).map(ResultHistoryEntryDtoFromJSON)),
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        'commentAttachmentsCount': json['commentAttachmentsCount'] == null ? undefined : json['commentAttachmentsCount'],
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TrackItTaskWorkResultDtoToJSON(value?: Omit<TrackItTaskWorkResultDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'state': ResultStateToJSON(value['state']),
        'output': BeamConstancyWorkResultDtoOutputToJSON(value['output']),
        'creatorUser': BeamConstancyWorkResultDtoCreatorUserToJSON(value['creatorUser']),
        'workStepId': value['workStepId'],
        'evaluationResults': value['evaluationResults'] == null ? undefined : ((value['evaluationResults'] as Array<any>).map(EvaluationResultDtoToJSON)),
        'trackItMeasurementId': value['trackItMeasurementId'],
        'trackItMeasurement': TrackItTaskWorkResultDtoTrackItMeasurementToJSON(value['trackItMeasurement']),
        'trackItDataTypesWithoutEvaluation': value['trackItDataTypesWithoutEvaluation'] == null ? undefined : ((value['trackItDataTypesWithoutEvaluation'] as Array<any>).map(TrackItDataTypeDtoToJSON)),
        'unmappedEvaluationIds': value['unmappedEvaluationIds'],
        'history': value['history'] == null ? undefined : ((value['history'] as Array<any>).map(ResultHistoryEntryDtoToJSON)),
        'commentCount': value['commentCount'],
        'lastComment': value['lastComment'],
        'commentAttachmentsCount': value['commentAttachmentsCount'],
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(PtwCommentDtoToJSON)),
        '$type': value['$type'],
    });
}

